module.exports = __webpack_public_path__ + "img/zuo@2x.d3415583.png";